
import { mapMutations } from 'vuex'
import BlogText3Section from '~/components/Common/Blog/BlogText3Section'
export default {
    name: 'NewYorkBond',
    components: { BlogText3Section },
}
